import React from "react"
import {
  StyledListDotted,
  StyledListItemDotted,
} from "@/components/LandingResources/ListDotted/StyledListDotted"
import { StyledNumberTxt } from "@/components/LandingResources/StyledResources"

const ListDotted = () => {
  return (
    <StyledListDotted>
      <StyledListItemDotted>
        Работаем более{" "}
        <StyledNumberTxt>
          <b>21</b>
        </StyledNumberTxt>
         года
      </StyledListItemDotted>
      <StyledListItemDotted>
        Находимся в Волгограде, отправляем заказы <b>по всей России</b>
      </StyledListItemDotted>
      <StyledListItemDotted>
        Следим за тем, чтобы все товары из нашего каталога всегда были
        в наличии. Для этого у нас есть 
        <StyledNumberTxt>
          <b>4</b>
        </StyledNumberTxt>
         больших склада с 
        <StyledNumberTxt>
          <b>10 000+</b>
        </StyledNumberTxt>{" "}
        видами товаров от эконом до премиум сегмента
      </StyledListItemDotted>
      <StyledListItemDotted>
        Доставляем заказанный товар по Волгоградской области день в день.
        У нас есть 
        <StyledNumberTxt>
          <b>13</b>
        </StyledNumberTxt>
         собственных машин, мы не зависим от загруженности сторонних
        перевозчиков
      </StyledListItemDotted>
      <StyledListItemDotted>
        Предоставляем <b>полный пакет закрывающих документов</b> сразу
        после доставки.
      </StyledListItemDotted>
      <StyledListItemDotted>
        Работаем с производителями товаров для бизнеса напрямую, за счёт
        чего предлагаем вам <b>стабильный широкий выбор и низкие цены</b>
      </StyledListItemDotted>
      <StyledListItemDotted>
        Производим пластиковую тару с возможностью{" "}
        <b>индивидуального дизайна</b>
      </StyledListItemDotted>
      <StyledListItemDotted>
        <b>Брендируем стаканчики, коробки, упаковки и пакеты</b> —
        если вы хотите получить что-то из перечисленного сразу с вашим
        логотипом, нужно просто сказать об этом менеджеру при оформлении заказа
      </StyledListItemDotted>
    </StyledListDotted>
  )
}

export { ListDotted }
